<template>
  <div class="footTypeDiv">
    <!-- <TwoTitles :title="i18n['title']" :brand-product-size="4" /> -->
    <div class="foot-container">
      <div class="foot-type narrow" :class="{ active: selectedFootType === 'S' }" @click="selectedFootType = 'S'">
        <p class="description">
          {{ i18n['narrow']['text'] }}
        </p>
        <img src="https://storage.googleapis.com/cleed-datacenter-europe/shoes/Pied-fin.svg" class="pied" :alt="i18n['narrow']['altImage']">
      </div>
      <div class="foot-type standard" :class="{ active: selectedFootType === 'M' }" @click="selectedFootType = 'M'">
        <p class="description">
          {{ i18n['standard']['text'] }}
        </p>
        <img src="https://storage.googleapis.com/cleed-datacenter-europe/shoes/Pied-standard.svg" class="pied" :alt="i18n['standard']['altImage']">
      </div>
      <div class="foot-type wide" :class="{ active: selectedFootType === 'L' }" @click="selectedFootType = 'L'">
        <p class="description">
          {{ i18n['wide']['text'] }}
        </p>
        <img src="https://storage.googleapis.com/cleed-datacenter-europe/shoes/Pied-large.svg" class="pied" :alt="i18n['wide']['altImage']">
      </div>
    </div>
    <ButtonSubmit v-if="selectedFootType" :text="i18n['button']" @submitButton="validateFootType(); $emit('manfield-get-sizes')" />
    <ButtonSubmit v-else :text="i18n['button_disable']" :class-name="'validateButtonSubmitDisable'" />
  </div>
</template>

<script>
import store from "@/store";
import ButtonSubmit from "@/components/modal/ui/ButtonSubmit.vue";
// import TwoTitles from "@/components/modal/ui/TwoTitles.vue";
import { customLogger } from "@/utils";

export default {
  name: "FootType",
  components: {
    ButtonSubmit,
    // TwoTitles
  },
  props: {
    i18n: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // selectedFootType: localStorage.getItem("selectedFootType") || null,
      selectedFootType: null,
      errorBrand: "",
    };
  },
  mounted() {
    if (store.state.user.modal_reco_sizeContent.foot_type) {
      this.selectedFootType = store.state.user.modal_reco_sizeContent.foot_type;
    }
  },
  methods: {
    validateFootType() {
      // Do something with the selected foot type
      //customLogger(`Selected foot type: ${this.selectedFootType}`);
      store.state.user.modal_reco_sizeContent.foot_type = this.selectedFootType;
      //localStorage.setItem("selectedFootType", this.selectedFootType);
      //customLogger("store.state.user.modal_reco_size", store.state.user.modal_reco_sizeContent);
      this.$emit("update-selected-option", "4");
    },
  },
};
</script>

<style scoped>
.foot-container {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.foot-type {
  margin: 0 10px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  cursor: pointer !important;
}

.foot-type p {
  margin: 5px 0 0 0 !important;
  text-align: center !important;
  font-size: 13px !important;
  text-decoration: none;
  color: #333;
  transition: all 0.3s ease-in-out;
}

.foot-type:hover p {
  text-decoration: underline;
  color: #666;
}

.pied {
  width: 100px !important;
  height: 200px !important;
  transition: all 0.3s ease-in-out;
}

.pied:hover {
  transform: scale(1.1);
}

.active p {
  text-decoration: underline;
  color: black;
  font-weight: bold;
}

.active .pied {
  transform: scale(1.1);

}

.footTypeDiv {
  margin: auto !important;
  min-height: 357px !important;
}
</style>
